import { arrayOfTaskLists } from "~/schemas/schema.task_lists.jsx";
import { arrayOfTasks, task } from "~/schemas/schema.tasks.jsx";
import * as actionTypes from "~/store/action_types";
import { makeGetTaskListIdByTaskIdSelector, makeGetProjectIdByTaskId } from "~/store/selectors/selector.tasks.jsx";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchTaskDependencies = (taskId) => {
  const url = `${Angie.api_url}/dependencies/tasks/${taskId}`;
  return {
    types: [
      actionTypes.FETCH_TASK_DEPENDENCIES_LOADING,
      actionTypes.FETCH_TASK_DEPENDENCIES_SUCCESS,
      actionTypes.FETCH_TASK_DEPENDENCIES_ERROR,
    ],
    callAPI: () => fetch({ url: url }),
    payload: {
      taskId,
      schema: {
        parents: arrayOfTasks,
        children: arrayOfTasks,
      },
    },
    cache: {
      key: url,
    },
  };
};

export const fetchProjectTaskDependencies = (projectId) => {
  return {
    types: [
      actionTypes.FETCH_PROJECT_TASK_DEPENDENCIES_LOADING,
      actionTypes.FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS,
      actionTypes.FETCH_PROJECT_TASK_DEPENDENCIES_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/dependencies/project/${projectId}`,
      }),
    payload: {
      projectId,
    },
  };
};

export const fetchTaskDependenciesSuggestions = (taskId, signal) => {
  return {
    types: [
      actionTypes.FETCH_TASK_DEPENDENCIES_SUGGESTIONS_LOADING,
      actionTypes.FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS,
      actionTypes.FETCH_TASK_DEPENDENCIES_SUGGESTIONS_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/dependencies/tasks/${taskId}/suggestions`,
        signal,
      }),
    payload: {
      taskId,
      schema: {
        tasks: arrayOfTasks,
        task_lists: arrayOfTaskLists,
      },
    },
  };
};

export const deleteTasksDependency = (taskId, dependencyId, projectId, is_parent) => {
  return {
    types: [
      actionTypes.DELETE_TASK_DEPENDENCIES_LOADING,
      actionTypes.DELETE_TASK_DEPENDENCIES_SUCCESS,
      actionTypes.DELETE_TASK_DEPENDENCIES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/dependencies/tasks/${taskId}`,
        method: `put`,
        body: {
          dependency_id: dependencyId,
        },
      }),
    payload: {
      taskId,
      projectId,
      is_parent,
      dependency_id: dependencyId,
    },
  };
};

export const createTasksDependency = (taskId, attributes) => (dispatch, getState) => {
  const getTaskListIdByTaskId = makeGetTaskListIdByTaskIdSelector();
  const getProjectIdByTaskId = makeGetProjectIdByTaskId();
  const taskListId = getTaskListIdByTaskId(getState(), taskId);
  const projectId = getProjectIdByTaskId(getState(), taskId);
  return dispatch({
    types: [
      actionTypes.ADD_TASK_DEPENDENCIES_LOADING,
      actionTypes.ADD_TASK_DEPENDENCIES_SUCCESS,
      actionTypes.ADD_TASK_DEPENDENCIES_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/dependencies/tasks/${taskId}`,
        method: `post`,
        body: { ...attributes },
      }),
    payload: {
      taskId,
      taskListId,
      projectId,
      ...attributes,
      schema: {
        parent: task,
        child: task,
      },
    },
  });
};

export const clearRescheduleSimulation = () => {
  return {
    type: actionTypes.CLEAR_RESCHEDULE_SIMULATION,
  };
};
